import { useState } from 'react';

import { getDisplayName, isDirectory } from '../helpers';

export interface DeleteItem {
  key: string;
  name: string;
  isDirectory: boolean;
}

export interface UseDeleteOperationsProps {
  handleDeleteFile: (key: string) => Promise<void>;
}

export const useDeleteOperations = ({ handleDeleteFile }: UseDeleteOperationsProps) => {
  const [deleteConfirmationOpen, setDeleteConfirmationOpen] = useState(false);
  const [itemToDelete, setItemToDelete] = useState<DeleteItem | null>(null);

  const handleDeleteRequest = (key: string) => {
    const isDir = isDirectory(key);
    const displayName = getDisplayName(key);

    setItemToDelete({
      key,
      name: displayName,
      isDirectory: isDir,
    });
    setDeleteConfirmationOpen(true);
  };

  const handleDeleteConfirmationClose = () => {
    setDeleteConfirmationOpen(false);
    setItemToDelete(null);
  };

  const handleDeleteConfirmationConfirm = async () => {
    if (!itemToDelete) return;

    try {
      await handleDeleteFile(itemToDelete.key);
      setDeleteConfirmationOpen(false);
      setItemToDelete(null);
    } catch (error) {
      console.error('Delete failed:', error);
    }
  };

  return {
    deleteConfirmationOpen,
    itemToDelete,
    handleDeleteRequest,
    handleDeleteConfirmationClose,
    handleDeleteConfirmationConfirm,
  };
};
